import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import { ICTextInput } from "../../core-component/form";
import {
  eyeIcon,
  leftArrow,
  visibilityEyeIcon,
} from "../../assets/icons/SvgIconList";
import { ICButton } from "../../core-component/ui";
import ICImage from "../../core-component/ui/ICImage";
import { routePublic } from "../../routes/PublicRoutePath";
import {
  initialValuesResetPass,
  submitResetPassword,
  validationSchemaResetPass,
} from "./ResetPasswordController";
import { decryptData } from "../../utils/AppFunctions";

const ResetPassword = () => {
  const { t } = UseTranslationHook();
  const location = useLocation();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const decryptParams = JSON.parse(decryptData(searchParams.get("at") ?? ""));

  const navigation = useNavigate();
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const validationSchema = validationSchemaResetPass(t);
  const formikInitialValues = {
    ...initialValuesResetPass,
  };
  const formik = useFormik({
    initialValues: formikInitialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      submitResetPassword(
        { ...values, token: decryptParams.token },
        navigation,
        setLoading,
        t
      );
    },
  });

  return (
    <div className="grid grid-cols-12">
      <div className="col-span-12 hidden md:flex md:col-span-6 lg:col-span-7 xl:col-span-8 h-svh w-full  items-center justify-center bg-base">
        <ICImage
          className="w-full "
          src={require("../../assets/image/app-logo.png")}
          alt={t("poster_image")}
        />
      </div>
      <div className="col-span-12 md:col-span-6  lg:col-span-5 xl:col-span-4 h-svh flex items-center justify-center bg-subtle">
        <div className="mx-6 sm:mx-6 md:mx-14 lg:mx-20 xl:mx-24">
          <div className="flex w-full justify-center ">
            <ICImage
              className="font-semibold text-4xl tracking-widest h-64 mb-4"
              src={require("../../assets/image/app-logo-server.jpg")}
              alt={t("poster_image")}
            />
          </div>
          <p className="font-bold text-3xl mt-4 text-center">
            {t("reset_password")}
          </p>
          <p className="text-muted text-sm text-center mt-2">
            {t("strong_password_instructions")}
          </p>
          <form className="rounded py-8" onSubmit={formik.handleSubmit}>
            <div className="mb-4">
              <ICTextInput
                required
                type={showNewPassword ? "text" : "password"}
                trailing={
                  showNewPassword ? (
                    <div
                      className="size-5"
                      onClick={() => {
                        setShowNewPassword(!showNewPassword);
                      }}
                    >
                      {eyeIcon}
                    </div>
                  ) : (
                    <div
                      className="size-5"
                      onClick={() => {
                        setShowNewPassword(!showNewPassword);
                      }}
                    >
                      {visibilityEyeIcon}
                    </div>
                  )
                }
                containerClassName="p-3"
                label={t("new_password")}
                name="new_password"
                value={formik.values.new_password}
                autoFocus
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                errorMessage={
                  formik.touched.new_password &&
                  formik.errors.new_password &&
                  formik.errors.new_password
                }
              />
            </div>
            <div className="mb-2">
              <ICTextInput
                required
                containerClassName="p-3"
                type={showPassword ? "text" : "password"}
                label={t("confirm_password")}
                trailing={
                  showPassword ? (
                    <div className="size-5" onClick={togglePasswordVisibility}>
                      {eyeIcon}
                    </div>
                  ) : (
                    <div className="size-5" onClick={togglePasswordVisibility}>
                      {visibilityEyeIcon}
                    </div>
                  )
                }
                name="confirm_password"
                value={formik.values.confirm_password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                errorMessage={
                  formik.touched.confirm_password &&
                  formik.errors.confirm_password &&
                  formik.errors.confirm_password
                }
              />
            </div>

            <div className="items-center justify-center mt-6">
              <ICButton
                className="w-full"
                type="submit"
                children={t("reset_password")}
                loading={loading}
              />
            </div>
            <div
              className="text-muted flex items-center justify-center cursor-pointer mt-2"
              onClick={() => {
                navigation("/" + routePublic.login);
              }}
            >
              <div className="size-4">{leftArrow}</div>
              <div className="ml-2 text-sm">{t("back_to_log_in")}</div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword;
